var _rect, _rect2, _rect3, _rect4, _path, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemLayoutWithDescCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 58,
    viewBox: "0 0 118 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 58,
    rx: 5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 16,
    width: 49,
    height: 4,
    rx: 1.5,
    fill: "#B4B3B3",
    stroke: "#939393"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 26.5,
    width: 93,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 37.5,
    width: 63,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8643 34.2529V35.7129H93.1123V34.2529H93.8643ZM93.7715 42.2266V43.5352H93.0244V42.2266H93.7715ZM94.5088 40.6494C94.5088 40.4606 94.4697 40.2962 94.3916 40.1562C94.3167 40.013 94.193 39.8844 94.0205 39.7705C93.848 39.6533 93.6169 39.5443 93.3271 39.4434C92.9105 39.2969 92.5459 39.1325 92.2334 38.9502C91.9242 38.7646 91.6833 38.5368 91.5107 38.2666C91.3415 37.9932 91.2568 37.653 91.2568 37.2461C91.2568 36.8457 91.348 36.499 91.5303 36.2061C91.7158 35.9131 91.973 35.6868 92.3018 35.5273C92.6305 35.3678 93.0146 35.2881 93.4541 35.2881C93.7926 35.2881 94.097 35.3385 94.3672 35.4395C94.6406 35.5404 94.8734 35.6885 95.0654 35.8838C95.2575 36.0791 95.404 36.32 95.5049 36.6064C95.609 36.8896 95.6611 37.2152 95.6611 37.583H94.4893C94.4893 37.3747 94.4648 37.1891 94.416 37.0264C94.3704 36.8604 94.3021 36.7204 94.2109 36.6064C94.1198 36.4893 94.0091 36.3997 93.8789 36.3379C93.752 36.276 93.6071 36.2451 93.4443 36.2451C93.2132 36.2451 93.0228 36.2891 92.873 36.377C92.7233 36.4616 92.6126 36.5788 92.541 36.7285C92.4727 36.8783 92.4385 37.0492 92.4385 37.2412C92.4385 37.4268 92.4743 37.5895 92.5459 37.7295C92.6175 37.8695 92.7396 37.9964 92.9121 38.1104C93.0879 38.221 93.3288 38.3333 93.6348 38.4473C94.0547 38.597 94.4176 38.7646 94.7236 38.9502C95.0329 39.1325 95.2705 39.3587 95.4365 39.6289C95.6058 39.8958 95.6904 40.2327 95.6904 40.6396C95.6904 41.0596 95.5928 41.416 95.3975 41.709C95.2054 42.002 94.9352 42.2249 94.5869 42.3779C94.2419 42.5277 93.8398 42.6025 93.3809 42.6025C93.0911 42.6025 92.8031 42.5651 92.5166 42.4902C92.2334 42.4121 91.9762 42.2852 91.7451 42.1094C91.514 41.9336 91.3301 41.7008 91.1934 41.4111C91.0566 41.1182 90.9883 40.7601 90.9883 40.3369H92.1699C92.1699 40.5908 92.2041 40.8024 92.2725 40.9717C92.3408 41.141 92.4336 41.2744 92.5508 41.3721C92.668 41.4697 92.7982 41.5397 92.9414 41.582C93.0879 41.6243 93.2344 41.6455 93.3809 41.6455C93.625 41.6455 93.8301 41.6048 93.9961 41.5234C94.1654 41.4388 94.2923 41.3216 94.377 41.1719C94.4648 41.0189 94.5088 40.8447 94.5088 40.6494Z",
    fill: "#3A3A3A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 57,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLayoutWithDescCenter);
export default __webpack_public_path__ + "static/media/ItemLayoutWithDescCenter.170dc2a96eeff9f70c2e7ee4477a8913.svg";
export { ForwardRef as ReactComponent };